export default __webpack_public_path__ + "images/fe7c9a639e46466e1401fa67ec3c930b-vizdata-texto.svg";